export default __webpack_public_path__ + "static/media/6H.5380d254.svg";